import Steps from 'antd-mobile/lib/steps';
export default Steps;



// WEBPACK FOOTER //
// ./components/steps/index.tsx